import type { FC } from 'react';

import InputDate from '../../../input_date/input_date';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'dateFormat',
  'outputFormat',
  'isRangeMode',
  'initialMonth',
  'optionsDropdown',
  'optionsPresets',
  'matchSelectValue',
  'formatSelectValue',
  'onValueChange',
  // validations prop used to disable unavailable dates in calendar
  // according to minDate and maxDate
  'validations',
  'relativeToDate',
  'isDynamicWidth',
] as const;

const Field = formField(InputDate, {
  defaultValue: '',
  transformProps: (props) => pickProps(props, componentProps),
});

export type DateFieldWrapperProps = FieldWrapperProps<typeof Field>;

const DateFieldWrapper: FC<DateFieldWrapperProps> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default DateFieldWrapper;
